import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OffersByCompanyHttpService } from './offers-by-company-http.service';
import { OffersByCompanyActions } from './offers-by-company.store';

@Injectable({
  providedIn: 'root',
})
export class OffersByCompanyEffects {
  public effects = createEffectFactory(OffersByCompanyActions, this.actions$);

  public fetch = this.effects(OffersByCompanyActions.fetchOne, ({ payload }) =>
    this.http.fetchOne$(<string>payload.id).pipe(
      map(response => ({
        data: response,
        id: response.id,
      })),
    ),
  );

  constructor(
    private http: OffersByCompanyHttpService,
    private store: Store,
    private actions$: Actions,
  ) {}
}
